const multiPromotionMixins = {
    data(){
        return{
            source:'',
            year:null,
            yearNum:'', //传给子组件
            currentStatus: '',                      //合同当前状态
        }
    },
    created(){
        let param = JSON.parse(sessionStorage.getItem('param'));
        this.source = param.source || "detail";
        this.currentStatus = param.currentStatus || ''; 
        this.year = param.year;
        this.yearNum = param.year.toString();
    },
    computed: {
        isLook(){
            return this.source=="detail";
        },
        isEdit(){
            return this.source=="edit";
        },
        isAdd(){
            return this.source=="add";
        },
    },
};
export default multiPromotionMixins;


// WEBPACK FOOTER //
// ./src/mixins/multipromotion.js